module.exports = __webpack_public_path__ + "media/1.aab2ad9f.wav";